import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.customMask)
    ? (_openBlock(), _createElementBlock("input", {
        key: 0,
        value: _ctx.maskedValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeText($event)))
      }, null, 40, _hoisted_1))
    : (_openBlock(), _createElementBlock("input", {
        key: 1,
        value: _ctx.maskedValue,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeText($event)))
      }, null, 40, _hoisted_2))
}